import { render, staticRenderFns } from "./automations.vue?vue&type=template&id=069421b0"
import script from "./automations.vue?vue&type=script&lang=js"
export * from "./automations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports